import {
    createRouter,
    createWebHistory
} from 'vue-router'

const routerHistory = createWebHistory()

import HomePage from './pages/home.vue'
import contactUs from './pages/contact-us.vue'
import unsubscribe from './pages/system/unsubscribe.vue'
import trademarkFaqs from './pages/trademark-faqs.vue'
import flatFeeTrademarkRegistrationPackage from './pages/flat-fee-trademark-registration-package.vue'
import international from './pages/international.vue'
import about from './pages/about.vue'
import privacyPolicy from './pages/privacy-policy.vue'
import termsOfUse from './pages/terms-of-use.vue'
import trademarkRegistrationProcess from './pages/trademark-registration-process/trademark-registration-process.vue'
import freeUsptoTrademarkSearch from './pages/free-uspto-trademark-search.vue'
import trademarkRegistrationThankYou from './pages/trademark-registration-process/thank-you.vue'

import TrademarkOfficeActionLayout from './pages/trademark-office-action/layout'
import TrademarkOfficeActionDesc from './pages/trademark-office-action/desc'
import TrademarkOfficeActionInfo from './pages/trademark-office-action/info'
import TrademarkOfficeActionConfirm from './pages/trademark-office-action/confirm'
import TrademarkOfficeActionStep1 from './pages/trademark-office-action/step1'
import TrademarkOfficeActionStep2 from './pages/trademark-office-action/step2'
import TrademarkOfficeActionStep3 from './pages/trademark-office-action/step3'
import TrademarkOfficeActionStep4 from './pages/trademark-office-action/step4'
import TrademarkOfficeActionStep5 from './pages/trademark-office-action/step5'
import TrademarkOfficeActionStep6 from './pages/trademark-office-action/step6'
import TrademarkOfficeActionPay from './pages/trademark-office-action/pay'
import TrademarkOfficeActionThankYou from './pages/trademark-office-action/thank-you'

import StatementOfUseLayout from './pages/statement-of-use/layout'
import StatementOfUseDesc from './pages/statement-of-use/desc'
import StatementOfUseInfo from './pages/statement-of-use/info'
import StatementOfUseConfirm from './pages/statement-of-use/confirm'
import StatementOfUseStepNumber from './pages/statement-of-use/step-number'
import StatementOfUseStepOwners from './pages/statement-of-use/step-owners'
import StatementOfUseStepUsing from './pages/statement-of-use/step-using'
import StatementOfUseStepProof from './pages/statement-of-use/step-proof'
import StatementOfUseStepEnd from './pages/statement-of-use/step-end'
import StatementOfUsePay from './pages/statement-of-use/pay'
import StatementOfUseThankYou from './pages/statement-of-use/thank-you'

import StatementOfUseExtensionLayout from './pages/statement-of-use-extension/layout'
import StatementOfUseExtensionDesc from './pages/statement-of-use-extension/desc'
import StatementOfUseExtensionInfo from './pages/statement-of-use-extension/info'
import StatementOfUseExtensionConfirm from './pages/statement-of-use-extension/confirm'
import StatementOfUseExtensionStep1 from './pages/statement-of-use-extension/step1'
import StatementOfUseExtensionStep2 from './pages/statement-of-use-extension/step2'
import StatementOfUseExtensionStep3 from './pages/statement-of-use-extension/step3'
import StatementOfUseExtensionStep4 from './pages/statement-of-use-extension/step4'
import StatementOfUseExtensionPay from './pages/statement-of-use-extension/pay'
import StatementOfUseExtensionThankYou from './pages/statement-of-use-extension/thank-you'

import TrademarkRenewalLayout from './pages/trademark-renewal/layout'
import TrademarkRenewalDesc from './pages/trademark-renewal/desc'
import TrademarkRenewalInfo from './pages/trademark-renewal/info'
import TrademarkRenewalConfirm from './pages/trademark-renewal/confirm'
import TrademarkRenewalStep1 from './pages/trademark-renewal/step1'
import TrademarkRenewalStep2 from './pages/trademark-renewal/step2'
import TrademarkRenewalStep3 from './pages/trademark-renewal/step3'
import TrademarkRenewalStep4 from './pages/trademark-renewal/step4'
import TrademarkRenewalStep5 from './pages/trademark-renewal/step5'
import TrademarkRenewalPay from './pages/trademark-renewal/pay'
import TrademarkRenewalThankYou from './pages/trademark-renewal/thank-you'

import TrademarkRevivalLayout from './pages/trademark-revival/layout'
import TrademarkRevivalDesc from './pages/trademark-revival/desc'
import TrademarkRevivalInfo from './pages/trademark-revival/info'
import TrademarkRevivalConfirm from './pages/trademark-revival/confirm'
import TrademarkRevivalStep1 from './pages/trademark-revival/step1'
import TrademarkRevivalStep2 from './pages/trademark-revival/step2'
import TrademarkRevivalStep3 from './pages/trademark-revival/step3'
import TrademarkRevivalPay from './pages/trademark-revival/pay'
import TrademarkRevivalThankYou from './pages/trademark-revival/thank-you'

import NotFound from './pages/NotFound'

const routers = createRouter({
    history: routerHistory,
    routes: [
        {
            path: '/',
            name: 'home',
            component: HomePage
        },
        {
            path: '/contact-us',
            name: 'contactUs',
            component: contactUs
        },
        {
            path: '/system/unsubscribe',
            name: 'unsubscribe',
            component: unsubscribe
        },
        {
            path: '/trademark-faqs',
            name: 'trademarkFaqs',
            component: trademarkFaqs
        },
        {
            path: '/flat-fee-trademark-registration-package',
            name: 'flatFeeTrademarkRegistrationPackage',
            component: flatFeeTrademarkRegistrationPackage
        },
        {
            path: '/about',
            name: 'about',
            component: about
        },
        {
            path: '/were-international',
            name: 'international',
            component: international
        },
        {
            path: '/privacy-policy',
            name: 'privacyPolicy',
            component: privacyPolicy
        },
        {
            path: '/terms-of-use',
            name: 'termsOfUse',
            component: termsOfUse
        },
        {
            path: '/trademark-registration-process',
            name: 'trademarkRegistrationProcess',
            component: trademarkRegistrationProcess
        },
        {
            path: '/free-uspto-trademark-search',
            name: 'freeUsptoTrademarkSearch',
            component: freeUsptoTrademarkSearch
        },
        {
            path: '/trademark-registration-process/thank-you',
            name: 'trademarkRegistrationThankYou',
            component: trademarkRegistrationThankYou
        },
        {
            path: '/trademark-office-action',
            component: TrademarkOfficeActionLayout,
            children: [
                {
                    path: '',
                    name: 'trademark-office-action-desc',
                    component: TrademarkOfficeActionDesc
                },
                {
                    path: 'info',
                    name: 'trademark-office-action-info',
                    component: TrademarkOfficeActionInfo
                },
                {
                    path: 'confirm',
                    name: 'trademark-office-action-confirm',
                    component: TrademarkOfficeActionConfirm
                },
                {
                    path: 'step-1/:number?',
                    name: 'trademark-office-action-step-1',
                    component: TrademarkOfficeActionStep1
                },
                {
                    path: 'step-2/:key',
                    name: 'trademark-office-action-step-2',
                    component: TrademarkOfficeActionStep2
                },
                {
                    path: 'step-3/:key',
                    name: 'trademark-office-action-step-3',
                    component: TrademarkOfficeActionStep3
                },
                {
                    path: 'step-4/:key',
                    name: 'trademark-office-action-step-4',
                    component: TrademarkOfficeActionStep4
                },
                {
                    path: 'step-5/:key',
                    name: 'trademark-office-action-step-5',
                    component: TrademarkOfficeActionStep5
                },
                {
                    path: 'step-6/:key',
                    name: 'trademark-office-action-step-6',
                    component: TrademarkOfficeActionStep6
                },
                {
                    path: 'step-pay/:key',
                    name: 'trademark-office-action-pay',
                    component: TrademarkOfficeActionPay
                },
                {
                    path: 'thank-you/:key',
                    name: 'trademark-office-action-thank-you',
                    component: TrademarkOfficeActionThankYou
                },
            ]
        },
        {
            path: '/statement-of-use',
            component: StatementOfUseLayout,
            children: [
                {
                    path: '',
                    name: 'statement-of-use-desc',
                    component: StatementOfUseDesc
                },
                {
                    path: 'info',
                    name: 'statement-of-use-info',
                    component: StatementOfUseInfo
                },
                {
                    path: 'confirm',
                    name: 'statement-of-use-confirm',
                    component: StatementOfUseConfirm
                },
                {
                    path: 'step-number/:number?',
                    name: 'statement-of-use-step-number',
                    component: StatementOfUseStepNumber
                },
                {
                    path: 'step-owners/:key',
                    name: 'statement-of-use-step-owners',
                    component: StatementOfUseStepOwners
                },
                {
                    path: 'step-using/:class/:key',
                    name: 'statement-of-use-step-using',
                    component: StatementOfUseStepUsing
                },
                {
                    path: 'step-proof/:class/:key',
                    name: 'statement-of-use-step-proof',
                    component: StatementOfUseStepProof
                },
                {
                    path: 'step-end/:key',
                    name: 'statement-of-use-step-end',
                    component: StatementOfUseStepEnd
                },
                {
                    path: 'step-pay/:key',
                    name: 'statement-of-use-pay',
                    component: StatementOfUsePay
                },
                {
                    path: 'thank-you/:key',
                    name: 'statement-of-use-thank-you',
                    component: StatementOfUseThankYou
                },
            ]
        },
        {
            path: '/statement-of-use-extension',
            component: StatementOfUseExtensionLayout,
            children: [
                {
                    path: '',
                    name: 'statement-of-use-extension-desc',
                    component: StatementOfUseExtensionDesc
                },
                {
                    path: 'info',
                    name: 'statement-of-use-extension-info',
                    component: StatementOfUseExtensionInfo
                },
                {
                    path: 'confirm',
                    name: 'statement-of-use-extension-confirm',
                    component: StatementOfUseExtensionConfirm
                },
                {
                    path: 'step-1/:number?',
                    name: 'statement-of-use-extension-step-1',
                    component: StatementOfUseExtensionStep1
                },
                {
                    path: 'step-2/:key',
                    name: 'statement-of-use-extension-step-2',
                    component: StatementOfUseExtensionStep2
                },
                {
                    path: 'step-3/:class/:key',
                    name: 'statement-of-use-extension-step-3',
                    component: StatementOfUseExtensionStep3
                },
                {
                    path: 'step-4/:key',
                    name: 'statement-of-use-extension-step-4',
                    component: StatementOfUseExtensionStep4
                },
                {
                    path: 'step-pay/:key',
                    name: 'statement-of-use-extension-pay',
                    component: StatementOfUseExtensionPay
                },
                {
                    path: 'thank-you/:key',
                    name: 'statement-of-use-extension-thank-you',
                    component: StatementOfUseExtensionThankYou
                },
            ]
        },
        {
            path: '/trademark-renewal',
            component: TrademarkRenewalLayout,
            children: [
                {
                    path: '',
                    name: 'trademark-renewal-desc',
                    component: TrademarkRenewalDesc
                },
                {
                    path: 'info',
                    name: 'trademark-renewal-info',
                    component: TrademarkRenewalInfo
                },
                {
                    path: 'confirm',
                    name: 'trademark-renewal-confirm',
                    component: TrademarkRenewalConfirm
                },
                {
                    path: 'step-1/:number?',
                    name: 'trademark-renewal-step-1',
                    component: TrademarkRenewalStep1
                },
                {
                    path: 'step-2/:key',
                    name: 'trademark-renewal-step-2',
                    component: TrademarkRenewalStep2
                },
                {
                    path: 'step-3/:class/:key',
                    name: 'trademark-renewal-step-3',
                    component: TrademarkRenewalStep3
                },
                {
                    path: 'step-4/:class/:key',
                    name: 'trademark-renewal-step-4',
                    component: TrademarkRenewalStep4
                },
                {
                    path: 'step-5/:key',
                    name: 'trademark-renewal-step-5',
                    component: TrademarkRenewalStep5
                },
                {
                    path: 'step-pay/:key',
                    name: 'trademark-renewal-pay',
                    component: TrademarkRenewalPay
                },
                {
                    path: 'thank-you/:key',
                    name: 'trademark-renewal-thank-you',
                    component: TrademarkRenewalThankYou
                },
            ]
        },
        {
            path: '/trademark-revival',
            component: TrademarkRevivalLayout,
            children: [
                {
                    path: '',
                    name: 'trademark-revival-desc',
                    component: TrademarkRevivalDesc
                },
                {
                    path: 'info',
                    name: 'trademark-revival-info',
                    component: TrademarkRevivalInfo
                },
                {
                    path: 'confirm',
                    name: 'trademark-revival-confirm',
                    component: TrademarkRevivalConfirm
                },
                {
                    path: 'step-1/:number?',
                    name: 'trademark-revival-step-1',
                    component: TrademarkRevivalStep1
                },
                {
                    path: 'step-2/:class/:key',
                    name: 'trademark-revival-step-2',
                    component: TrademarkRevivalStep2
                },
                {
                    path: 'step-3/:key',
                    name: 'trademark-revival-step-3',
                    component: TrademarkRevivalStep3
                },
                {
                    path: 'step-pay/:key',
                    name: 'trademark-revival-pay',
                    component: TrademarkRevivalPay
                },
                {
                    path: 'thank-you/:key',
                    name: 'trademark-revival-thank-you',
                    component: TrademarkRevivalThankYou
                },
            ]
        },
        { path: '/:pathMatch(.*)', name: 'not-found', component: NotFound }
    ]
})

export default routers
